import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import defaultHiyaImg from './RoomShare/images/defaultHiya.png'

// 获取站外分享的一个adjust链接 http://wiki.xunlei.cn/pages/viewpage.action?pageId=161236872
export const get_common_share_info = createAsyncThunk(
  'ShareOut/get_common_share_info',
  async (share_id: any) => {
    const resp = await http.post('/live/misc/get_common_share_info', {
      share_id,
    })
    return resp.data.data
  }
)

// 房间分享
export const getShareRoomInfo = createAsyncThunk(
  'RoomShare/live/room/share',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/room/share', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

export const reportData = createAsyncThunk(
  'RoomShare/stat/action',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/stat/action', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

export interface InitialStateType {
  adjust_link?: string
  link?: string
  title?: string
  content?: string
  share_image?: string
  assets?: {
    image_width?: number
    image_height?: number
    room_info?: {
      room_id?: number
      mid?: number
      cover?: string
      title?: string
    }
  }
  app?: string
  package?: string
  myPackage?: string
  room_info?: {
    room_id?: number
    mid?: number
    cover?: string
    title?: string
  }
}

const initialState: InitialStateType = {
  assets: {
    room_info: {
      title: 'Hiya',
      cover: defaultHiyaImg,
      room_id: 1010,
    },
  },
}

export const ShareOutSlice = createSlice({
  name: 'ShareOut',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_common_share_info.fulfilled, (state, action) => {
      try {
        Object.assign(state, {
          ...action.payload,
          myPackage: action.payload?.package,
          room_info: action.payload?.assets?.room_info
            ? JSON.parse(action.payload?.assets?.room_info)
            : undefined,
        })
      } catch (error) {
        //
      }
    })
  },
})

export default ShareOutSlice.reducer
